import React from "react";
import LeftAboutSection1 from "./section1Left/LeftAboutSection1";
import RightAboutSection1 from "./section1Right/RightAboutSection1";

const AboutSection1 = () => {
  return (
    <div id="message">
      <div className=" mt-48 lg:flex justify-between lg:w-[90%] lg:mx-auto ">
        <LeftAboutSection1 />

        <RightAboutSection1 />
      </div>
    </div>
  );
};

export default AboutSection1;
